module.exports = __webpack_public_path__ + "assets/img/banner.c8c3147e.jpg";